import React from 'react';
import { Star, ExternalLink, ShieldCheck, ShoppingBag } from 'lucide-react';
export function ReviewsPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-553">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-554">
        <div className="max-w-4xl mx-auto text-center" data-id="element-555">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-556">
            <Star className="w-8 h-8 text-[#0e7be1]" data-id="element-557" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-558">
              Real Testimonials
            </h1>
          </div>
          <p className="text-xl text-gray-600 mb-6" data-id="element-559">
            From Athletes and Everyday People
          </p>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full" data-id="element-560"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-561">
        {/* Video Section */}
        <section className="text-center" data-id="element-562">
          <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-lg bg-black mb-4" data-id="element-563">
            <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube-nocookie.com/embed/wXmLRLaUMzU?rel=0" title="NeoLife Testimonials" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-564"></iframe>
          </div>
          <p className="text-sm text-gray-500 italic" data-id="element-565">
            Results will vary from person to person.
          </p>
        </section>

        {/* Blog Link CTA */}
        <section className="bg-green-50 border border-green-100 rounded-2xl p-8 text-center hover:shadow-md transition-shadow duration-200" data-id="element-566">
          <a href="http://neolifeblog.com/2015/06/real-people-real-stories/" target="_blank" rel="noopener noreferrer" className="group inline-flex flex-col items-center gap-2" data-id="element-567">
            <span className="text-2xl md:text-3xl font-bold text-[#1a8f3c] group-hover:text-[#146c2e] transition-colors text-center leading-tight" data-id="element-568">
              Click here to see real Weight Loss results,
              <br data-id="element-569" />
              from real people with NeoLife
            </span>
            <span className="flex items-center text-[#1a8f3c] font-medium mt-2 group-hover:underline" data-id="element-570">
              Read their stories on our blog{' '}
              <ExternalLink className="w-4 h-4 ml-1" data-id="element-571" />
            </span>
          </a>
        </section>

        {/* Guarantee Section */}
        <section className="bg-blue-50 border border-blue-100 rounded-2xl p-8 md:p-10" data-id="element-572">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8" data-id="element-573">
            <div className="flex-shrink-0 bg-white p-4 rounded-full shadow-sm text-[#0e7be1]" data-id="element-574">
              <ShieldCheck className="w-10 h-10" data-id="element-575" />
            </div>
            <div className="flex-1 text-center md:text-left" data-id="element-576">
              <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-577">
                100% 30-Day Money Back Guarantee
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-578">
                Now try the products for yourself. If you are not completely
                satisfied with anything you buy, simply return it for a refund.
              </p>
              <a href="https://www.bestvitaminsforall.com/15m8/gnld-neolife-products.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-[#0e7be1] hover:bg-[#0b63b6] transition-colors shadow-sm" data-id="element-579">
                <ShoppingBag className="w-5 h-5 mr-2" data-id="element-580" />
                Click here to see all GNLD NeoLife products
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>;
}